import { attachFloating } from "./floating-position";
import { mountPortal } from "./portal";
export function popoverContains(anchor, floating, node) {
  if (!node) {
    return false;
  }
  return Boolean(anchor?.contains(node) || floating?.contains(node));
}
export function shouldDismissPopoverFocus(anchor, floating, relatedTarget) {
  if (!(relatedTarget instanceof Node)) {
    return true;
  }
  return !popoverContains(anchor, floating, relatedTarget);
}
export function shouldDismissPopoverPointer(anchor, floating, target) {
  return !popoverContains(anchor, floating, target);
}
export class PopoverController {
  config;
  cleanupFloating = null;
  portalHandle = null;
  floatingElement = null;
  constructor(config) {
    this.config = config;
  }
  updateConfig(patch) {
    this.config = {
      ...this.config,
      ...patch
    };
  }
  sync() {
    const floating = this.resolveFloating();
    if (!floating) {
      return;
    }
    const open = this.config.getOpen();
    if (!open) {
      this.teardown();
      floating.toggleAttribute("hidden", true);
      return;
    }
    const anchor = this.config.getAnchor();
    if (!anchor) {
      return;
    }
    floating.toggleAttribute("hidden", false);
    const usePortal = this.config.portal !== false;
    if (usePortal) {
      if (!this.portalHandle) {
        this.portalHandle = mountPortal(floating, this.config.portalContainer ?? document.body);
      }
    } else if (this.portalHandle) {
      this.portalHandle.unmount();
      this.portalHandle = null;
    }
    this.teardownFloating();
    this.cleanupFloating = attachFloating({
      anchor,
      floating,
      getPlacement: this.config.getPlacement,
      gap: this.config.gap ?? 8,
      matchAnchorWidth: this.config.matchAnchorWidth
    });
  }
  contains(node) {
    return popoverContains(this.config.getAnchor(), this.resolveFloating(), node);
  }
  getFloatingElement() {
    return this.resolveFloating();
  }
  teardown() {
    this.teardownFloating();
    if (this.portalHandle) {
      this.portalHandle.unmount();
      this.portalHandle = null;
    }
  }
  destroy() {
    this.teardown();
    this.floatingElement = null;
  }
  resolveFloating() {
    const configuredFloating = this.config.getFloating();
    if (configuredFloating) {
      this.floatingElement = configuredFloating;
    }
    return configuredFloating ?? this.floatingElement;
  }
  teardownFloating() {
    this.cleanupFloating?.();
    this.cleanupFloating = null;
  }
}